<template>
  <div :class="['layout', isFirstTab ? 'no-top' : '']">
    <HeaderTabBar />
    <Banner v-if="isFirstTab" :list="list" />
    <CountDown v-if="isFirstTab" />
    <div :class="['route-view-wrapper', isFirstTab ? 'no-top' : '']">
      <router-view />
    </div>
    <Footer />
    <!-- 全局登录弹窗 -->
    <LoginModal :open="open" />
  </div>
</template>
<script setup>
import { computed } from "vue";
import store from "@/store";
import { useRoute } from "vue-router";

import HeaderTabBar from "@/components/PC/HeaderTabBar.vue";
import Footer from "@/components/PC/Footer.vue";
import CountDown from "@/components/PC/CountDown.vue";
import Banner from "@/components/PC/Banner.vue";
import LoginModal from "./LoginModal.vue";

const route = useRoute();
const open = computed(() => store.getters["user/getPcLoginPop"]);
const tabList = store.getters["config/getTabList"];
const isFirstTab = computed(() => tabList[0].subjectId == route.query.id);

const list = computed(() => {
  const bannerList = store.getters["config/getConfig"].bannerPc
    ? store.getters["config/getConfig"].bannerPc.split(",")
    : [];
  const urlList = store.getters["config/getConfig"].bannerPcToUrl
    ? store.getters["config/getConfig"].bannerPcToUrl.split(",")
    : [];
  const list = bannerList.map((item, index) => {
    return {
      banner: item,
      url: urlList[index],
    };
  });
  return list;
});
</script>

<style lang="less" scoped>
.layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  .route-view-wrapper {
    flex: 1;
    padding-top: 60px;

    &.no-top {
      padding-top: 0;
    }
  }
}
</style>
